<template>
    <v-flex class="card_box" xs6 sm3 md2 lg2>
        <v-card class="custom_card" @click="clickHandler">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <div class="custom_card_icon" v-on="on">
                        <i :class="'fas fa-' + iconAugmentationAction(augmentation.action_type)" v-on="on" />
                    </div>
                </template>
                <span>{{ nameAugmentationAction(augmentation.action_type) }}</span>
            </v-tooltip>
            <div v-if="modeDelete" :class="[augmentationIsSelect(augmentation._id) ? 'checked' : '']"
                 class="trash_checkbox" />
            <div v-if="modeDelete" :class="[augmentationIsSelect(augmentation._id) ? 'checked' : '']"
                 class="card_overlay" />
            <v-img v-if="augmentation.images[0]" :src="'image/' + augmentation.images[0]"
                   class="white--text custom_card_image_bg" />
            <v-img v-else class="white--text custom_card_image_bg" src="img/bg_default.jpg" />
            <div class="custom_card_overlay" />
            <span class="custom_card_text">{{ augmentation.name }}</span>
        </v-card>
    </v-flex>
</template>

<script>
    import { actionTypes } from '../global/actionTypes';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'AugmentationsCards',
        props: {
            augmentation: {
                type: Object,
                default: function () {
                    return {
                        _id: '',
                        name: '',
                        action_type: '',
                        images: []
                    };
                }
            }
        },
        computed: {
            ...mapGetters('augmentations', ['mode', 'augmentationIsSelect', 'currentExperienceToken']),
            modeDelete: function () {
                return this.mode.includes('delete');
            }
        },
        methods: {
            ...mapActions('augmentations', ['handleDeleteAugmentation']),
            clickHandler: function () {
                let callback = this.mode === '' ? this.redirection
                    : this.mode === 'delete' ? this.handleDeleteAugmentation : () => {
                        this.$toasted.error(new Error('Undefined action'));
                    };
                callback(this.augmentation._id);
            },
            redirection: function () {
                this.$router.push({
                    name: 'actions',
                    params: {
                        experienceToken: this.currentExperienceToken,
                        augmentationToken: this.augmentation._id
                    }
                });
            },
            iconAugmentationAction: function (value) {
                let res = actionTypes.filter((action) => action.type === value)[0];
                return res ? res.icon : 'question';
            },
            nameAugmentationAction: function (value) {
                let res = actionTypes.filter((action) => action.type === value)[0];
                return res ? res.name : '???';
            }
        }
    };
</script>

<style lang="scss" scoped>

    .card_box {
        padding: 10px !important;
        height: 150px;
    }

    .custom_card {
        background-color: #FFF;
        transition: 0.3s ease;
        cursor: pointer;
        border-radius: 5px;
        height: 100%;
        min-height: 130px;
        overflow: hidden;
        box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
    }

    .custom_card:hover {
        transform: scale(1.025);
        transition: transform 0.2s;
    }

    .custom_card_image_bg {
        min-height: 100%;
        min-width: 100%;
    }

    .custom_card_text {
        position: absolute;
        left: 7px;
        bottom: 0;
        color: #FFF;
        font-size: 20px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: calc(100% - 10px);
    }

    .custom_card_overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 30%;
        background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8));
    }

    .trash_checkbox {
        position: absolute;
        display: block;
        z-index: 2;
        width: 2vh;
        height: 2vh;
        left: 1vh;
        top: 1vh;
        transition: 0.3s ease;
        background-color: #FFF;
        border-radius: 5px !important;
        border: 3px white solid;
    }

    .trash_checkbox.checked {
        background-color: #ff3860 !important;
        transition: 0.3s ease;
    }

    .card_overlay {
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 1;
        top: 0;
        left: 0;
        background-color: #ff3860;
        opacity: 0.3;
        border-radius: 5px;
        transition: opacity 0.3s ease;
    }

    .card_overlay.active {
        opacity: 0.5;
        transition: opacity 0.3s ease;
    }

    .custom_card_icon {
        position: absolute;
        top: 0;
        right: 0;
        height: 50px;
        width: 50px;
        background-color: #393E46;
        z-index: 1;
        border-radius: 0 0 0 50% !important;
        border-bottom: 1px rgba(0, 0, 0, 0.5) solid;
        border-left: 1px rgba(0, 0, 0, 0.5) solid;
        box-shadow: -5px 5px 40px rgba(0, 0, 0, 0.6);
    }

    .custom_card_icon i {
        color: white;
        font-size: 25px;
        top: 45%;
        position: relative;
        transform: translateY(-50%);
    }
</style>
